(() => {
  if (window.__astraReviewLoaded) return;
  window.__astraReviewLoaded = true;
  const screenPurchase = (component) => component && [...document.querySelectorAll('astra-grade-selector[data-aa-trim-only]')].some((selector) => selector.dataset.productId === component.dataset.productId);
  const pending = (component, value) => {
    if (!screenPurchase(component)) return;
    if (value) component.dataset.aaPurchasePending = 'true';
    else component.removeAttribute('data-aa-purchase-pending');
    const button = component.querySelector('[data-testid="standalone-add-to-cart"]');
    if (button) {
      if (value) button.dataset.aaPurchasePending = 'true';
      else button.removeAttribute('data-aa-purchase-pending');
      button.setAttribute('aria-busy', String(value));
    }
    document.dispatchEvent(new CustomEvent('aa:purchase-pending-change'));
  };
  document.addEventListener('submit', (event) => {
    const component = event.target instanceof Element && event.target.closest('product-form-component');
    if (component?.dataset.aaPurchasePending !== 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('shopify:cart:lines-update', (event) => {
    if (event.action !== 'add' || !event.promise || !(event.target instanceof Element)) return;
    const component = event.target.closest('product-form-component');
    if (!component || !document.body.classList.contains('aa-page--product') || component.closest('dialog, .aa-pair__dialog, .quick-add-modal')) return;
    pending(component, true);
    event.promise.then(({ detail }) => {
      if (detail?.didError) { pending(component, false); return; }
      window.location.assign(window.Theme?.routes?.cart_url || ((window.Shopify?.routes?.root || '/') + 'cart'));
    }).catch(() => pending(component, false));
  });
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('product-form-component[data-aa-purchase-pending]').forEach((component) => pending(component, false));
  });
})();
